import React from "react";

import { parseDocType } from "EmployerApplication/Components/documentPicker/utils";

import BodyText from "Common/BodyText";
import { Ol } from "Common/HTML";

import type { UploadDocsProp } from "Utils/types";

export const remoteDocsDescription = (props: UploadDocsProp) => {
  const docType = parseDocType(props.fileInputName);

  switch (docType) {
    case "state_wage_report":
      return <StateWageReport {...props} />;
    case "payroll_journal":
      return <PayrollJournal {...props} />;
    case "w4":
      return <W4 {...props} />;
    default:
      return props.description;
  }
};

const StateWageReport = () => (
  <>
    <BodyText>
      If you prepared these forms through Remote, reach out to{" "}
      <BodyText componentClass="span" weight="bold">
        gp-help@remote.com
      </BodyText>{" "}
      and request them. Remote will send the forms to SimplyInsured.{" "}
    </BodyText>
    <BodyText mt={3}>If you prepared these forms prior to starting payroll with Remote, contact your accounting team to ask for these forms.</BodyText>
  </>
);

const PayrollJournal = (props) => (
  <BodyText>
    Reach out to{" "}
    <BodyText componentClass="span" weight="bold">
      gp-help@remote.com
    </BodyText>{" "}
    and request this report. Please include the date range listed below in your request.
  </BodyText>
);

const W4 = () => (
  <BodyText>
    A signed W-4 form is needed for each employee. Instructions on where to download them:
    <br />
    <Ol my={2}>
      <li>
        In Remote, select the{" "}
        <BodyText componentClass="span" weight="bold">
          Team
        </BodyText>{" "}
        menu on the left side of the screen.
      </li>
      <li>Click on the employee's name.</li>
      <li>
        Select the{" "}
        <BodyText componentClass="span" weight="bold">
          Files
        </BodyText>{" "}
        tab.
      </li>
      <li>You will find the W-4 form in this section.</li>
      <li>
        Reach out to{" "}
        <BodyText componentClass="span" weight="bold">
          gp-help@remote.com
        </BodyText>{" "}
        if you cannot find these files.
      </li>
    </Ol>
    After downloading the PDF file, upload it here by clicking the input field below.
  </BodyText>
);
